<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input placeholder="请输入报警代码查询" v-model="params.warning_code" clearable prefix-icon="el-icon-search" @change="onSearch()" />
      </el-col>
      <el-col :span="5" class="col_pos_right" align="right">
        <el-button v-permission="'新增报警'" icon="el-icon-plus" @click="addWarn()">新增报警</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)">
          <template slot-scope="scope">
            <span>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="160" label="操作">
          <template slot-scope="scope">
            <el-link v-for="item in $operationsFilter(operations)" :key="item.key" :type="item.type" @click="handleClick(item.operation, scope.row)">{{ item.title }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :rowData="rowData" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import warnAdd from './add'
import warnEdit from './edit'
import Util from '@/api/util'

export default {
  name: '',
  data () {
    return Backend.initListPage(this, 'device_warning_setting', {
      route_name: '报警设置列表',
      id_name: 'warning_setting_id',
      tableColList: [
        {
          key: 'warning_code',
          name: '报警代码'
        },
        {
          key: 'warning_type_desp',
          name: '报警类型'
        },
        {
          key: 'warning_level_desp',
          name: '报警级别'
        },
        {
          key: 'warning_name',
          name: '报警名称'
        }
      ],
      operations: [
        {
          key: 'edit',
          title: '编辑',
          icon: 'icon-bianji icon_1',
          permiss: '编辑报警',
          type: 'primary',
          operation: 'editRow'
        },
        {
          key: 'delete',
          title: '删除',
          icon: 'icon-shanchu icon_6',
          permiss: '删除报警',
          type: 'danger',
          operation: 'deleteRow'
        }
      ],
      params: { warning_code: '' },
      dialogVisible: false,
      title: '',
      componet_select: '',
      rowData: {}
    })
  },

  components: {
    'warn-add': warnAdd,
    'warn-edit': warnEdit
  },

  methods: {
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    addWarn () {
      this.title = '新增报警'
      this.dialogVisible = true
      this.componet_select = 'warn-add'
    },
    handleClick (operation, row) {
      this[operation](row)
    },
    editRow (row) {
      this.title = '编辑报警'
      this.dialogVisible = true
      this.componet_select = 'warn-edit'
      this.rowData = row
    },
    deleteRow (row) {
      Backend.deleteRow(this, row)
    }
  }
}
</script>
